/*
 * @Author: libo 
 * @Date: 2020-11-13 17:12:56 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-01-24 10:15:36
 */

<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <meter-priceinfo-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></meter-priceinfo-form>
  </j-modal>
</template>

<script>

  import MeterPriceinfoForm from './MeterPriceinfoForm'
  export default {
    name: 'MeterPriceinfoModal',
    components: {
      MeterPriceinfoForm
    },
    data () {
      return {
        title:'',
        width:1024,
        visible: false,
        disableSubmit: false,
        isUsed: false// 是否已使用
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.isUsed = this.isUsed;
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.isUsed = this.isUsed;
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {  //关闭按钮后回到默认
        this.$refs.realForm.shut();
        this.close()
      }
    }
  }
</script>